import { render, staticRenderFns } from "./Corporators.vue?vue&type=template&id=127e21ee"
import script from "./Corporators.vue?vue&type=script&lang=js"
export * from "./Corporators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports